module.exports = __webpack_public_path__ + "img/equipe_plan-de-travail2.1b157743.jpg";